export const LogoMark = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden="true">
    <path d="M20 2 L34 7 V19 C34 28 28 35 20 38 C12 35 6 28 6 19 V7 Z" fill="#059669" />
    <path d="M12.5 20.5 L18 26 L28 14.5" stroke="#ffffff" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Logo = ({ dark = false }) => (
  <div className="flex items-center gap-2.5" data-testid="brand-logo">
    <LogoMark />
    <div className="leading-none">
      <span className={`block font-display font-extrabold tracking-tight text-base sm:text-lg ${dark ? "text-white" : "text-slate-900"}`}>
        NOLEGGIO SICURO
      </span>
      <span className={`block text-[9px] font-mono uppercase tracking-[0.28em] mt-1 ${dark ? "text-emerald-400" : "text-emerald-700"}`}>
        × DoYou Italy
      </span>
    </div>
  </div>
);
